@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.content {
  text-align: center;
  gap: @space-8;
  align-items: center;
}

.success-icon {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}
